<template>
  <v-dialog
      v-model="isDisplay"
      width="750px"
      persistent
      no-click-animation
  >
    <v-card>
      <v-container>
        <v-row>
            <v-card-title class="headline">CSV入出力</v-card-title>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn
                  @click.stop="close()"
                  text
              >
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-card-actions>
        </v-row>

        <v-card-title class="font-weight-bold">ダウンロード</v-card-title>

        <v-row
            align="center"
            justify="center"
        >
          <v-col cols="8">
            <v-text-field
                v-model="this.outputFileName"
                readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-btn
                rounded
                class="common-save-btn"
                @click.stop="csvDownload()"
            >
              CSVダウンロード
              <v-icon
                  right
                  dark
              >
                mdi-download
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-divider class="mx-3"></v-divider>

        <v-card-title class="font-weight-bold">アップロード</v-card-title>

        <FileUpload
            ref="fileUploadComponent"
            isFileSelect
            accept=".csv"
            title="ファイル選択"
            max-height="200"
            @fileUploadClose="fileUploadClose()"
        />

        <CsvContents/>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import FileUpload from './FileUpload'
import CsvContents from './CsvContents'
import {saveAs} from "file-saver"

export default ({
  components: {
    FileUpload,
    CsvContents
  },
  data: () => ({
    outputFileName: '',
    isDisplay: false,
    isUpload: false,
  }),
  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.setDownloadFileName();
      this.isDisplay = false;
      this.isUpload = false;
    },
    async csvDownload() {
      await axios.post('/user/csvDownload', [], {responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], {
              type: response.data.type
            });
            saveAs(blob, this.outputFileName);
          })
    },
    setDownloadFileName() {
      let today = new Date();
      this.outputFileName = "" + today.getFullYear()
          + (today.getMonth() + 1)
          + today.getDate()
          + today.getHours()
          + today.getMinutes()
          + today.getSeconds()
          + "-担当者一覧.csv";
    },
    close() {
      this.isDisplay = false;
      this.$refs.fileUploadComponent.initFileElement();
    },
    fileUploadClose() {
      this.$store.dispatch('modal/open',  {
            isOpen: true,
            message: '担当者を更新しました。',
          }
      ).then(() => {
        this.$emit("dialogClose");
        this.isDisplay = false;
      })
    }
  }
})
</script>